<template>
  <div class="grid-view-cameras d-flex flex-column align-items-start">
    <el-link
      v-for="{ id, name, link } in items"
      :key="id"
      class="mb-1"
      icon="el-icon-document"
      type="primary"
      :underline="false"
      target="_blank"
      :href="addSlashIfNeeded(link)"
      >{{ name }}
    </el-link>
  </div>
</template>

<script>
export default {
  name: 'CamerasField',
  props: {
    content: {
      type: Array,
    },
  },
  computed: {
    items() {
      return this.content || []
    },
  },
  methods: {
    addSlashIfNeeded(link) {
      if (typeof link === 'string' && link.length) {
        if (link[0] === '/' || link.match(/^http/)) return link // @regex http-vel kezdodik
        return `/${link}`
      } else {
        return link
      }
    },
  },
}
</script>
